import React from "react"
import { Redirect, Route, RouteProps, Switch } from "react-router-dom"

import { StartPagePath } from "./paths"
import {
	ExternalLogin,
	LoginWithKeycodeProtectedScreenContent,
	LoginWithPasswordProtectedScreenContent,
	LoginWithSamlProtectedScreenContent,
	MasterLogin,
	ResetPasswordConfirmProtectedScreenContent,
	ResetPasswordProtectedScreenContent,
	RoleProtectedScreenContent,
	TwoFactorAuthenticationProtectedScreenContent
} from "../screens"

export const StartPageOutlet = () => (<Switch>
	<LoginRoute path="/login" component={LoginWithPasswordProtectedScreenContent} />
	<LoginRoute path="/keycode"
		component={LoginWithKeycodeProtectedScreenContent} />
	<LoginRoute path="/saml" component={LoginWithSamlProtectedScreenContent} />
	<LoginRoute path="/reset-password" component={ResetPasswordProtectedScreenContent} />
	<LoginRoute path="/reset-password-confirm/:token"
		component={ResetPasswordConfirmProtectedScreenContent} />
	<LoginRoute path="/role" component={RoleProtectedScreenContent} />
	<LoginRoute path="/2fa"
		component={TwoFactorAuthenticationProtectedScreenContent} />
	<LoginRoute path="/master-login" component={MasterLogin} />
	<LoginRoute path="/external-login" component={ExternalLogin} />
	<LoginRoute path="*"><Redirect to="/" /></LoginRoute>
</Switch>)

const LoginRoute = (props: Omit<RouteProps, "path"> & {
	path: StartPagePath
}) => <Route {...props} />
